import { OptionsItemLayoutData, OptionsItemLayoutDefinitionData, OptionsItemLiveData, OptionsItemLocData, OptionsItemThemeData } from "../../../types/types";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { OptionsItemType } from "./OptionsItem";
import { SettingsItem } from "./SettingsItem";


export class OptionsItemBase
    extends SettingsItem {
    // All live data; JSON Node ref; Handle with care!
    protected itemLayoutData: OptionsItemLayoutData;
    protected itemThemeData: OptionsItemThemeData;
    protected itemLocData: OptionsItemLocData;
    protected itemLiveData: OptionsItemLiveData;
    // separate delimiter line addition
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;
    protected _isMobile: boolean;


    // EDIT: we need this before item has itemLayoutData set (during Build) as well. 
    // But it is also useful when removing item back to pool, so keep it here too.
    public GetType(): OptionsItemType {
        const itemLayoutDef: OptionsItemLayoutDefinitionData = LayoutDataManager.GetItemDefinitionData(this.itemLayoutData.id);
        return itemLayoutDef.itemType;
    }

    public GetId(): string {
        return this.itemLayoutData.id;
    }

    /**
     * Does trigger from both when setting ALL data or just from localization change (itemLocData only)
     * 
     * @param itemLayoutData 
     * @param itemThemeData 
     * @param itemLocData 
     * @param itemLiveData 
     */
    public SetData(
        itemLayoutData: OptionsItemLayoutData = undefined,
        itemThemeData: OptionsItemThemeData = undefined,
        itemLocData: OptionsItemLocData = undefined,
        itemLiveData: OptionsItemLiveData = undefined,
        hasDelimiterLine: boolean,
    ): void {
        if (itemLayoutData != undefined) {
            this.itemLayoutData = itemLayoutData;
        }
        if (itemThemeData != undefined) {
            this.itemThemeData = itemThemeData;
        }
        if (itemLocData != undefined) {
            this.itemLocData = itemLocData;
        }
        if (itemLiveData != undefined) {
            this.itemLiveData = itemLiveData;
        }
        this.hasDelimiterLine = hasDelimiterLine;

        if (itemLocData != undefined || itemLiveData != undefined) {
            this.UpdateViewFromDataChange(itemLocData, itemLiveData);
        }
    }

    public RegisterListeners(): void {
        // console.log("RegisterListeners");

        // override in subclass
    }

    public UnregisterListeners(): void {
        // console.log("UnregisterListeners");

        // override in subclass
    }

    public UpdateViewFromDataChange(
        itemLocData: OptionsItemLocData = undefined,
        itemLiveData: OptionsItemLiveData = undefined
    ): void {
        // override in subclass
    }

    // public UpdateFromLocalizationChange(): void
    // {
    //     // override in subclass
    // }
}